<template>
  <div class="page_zeroRepairList">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="姓名" size="small">
              <el-input v-model="listQuery.name" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.projectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="身份证号码" size="small">
              <el-input v-model="listQuery.idCardNumber" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="90px">
          <div>
            <el-form-item label="联系方式" size="small">
              <el-input v-model="listQuery.contactInfo" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="个税申报类型" size="small" label-width="115px">
              <el-select v-model="listQuery.taxDeclarationType" placeholder="" clearable filterable style="width:180px">
                <el-option value="正常工资薪金"></el-option>
                <el-option value="劳务报酬"></el-option>
                <el-option value="全年一次性奖金（一次扣税）"></el-option>
                <el-option value="全年多次性奖金（多次发放）"></el-option>
                <el-option value="解除劳动合同一次性补偿"></el-option>
                <el-option value="个税差额补发"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="法务主体" size="small">
              <el-select v-model="listQuery.legalEntity" placeholder="" clearable filterable style="width:180px" size="small">
                <el-option v-for="(item,index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属期" size="small">
              <el-date-picker v-model="listQuery.period" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>往年薪资查询</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="expHandle">导入历史发薪</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="name" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="idCardNumber" label="身份证" min-width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="taxDeclarationType" label="个税申报类型" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="legalEntity" label="法务主体" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="period" label="所属期" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ moment(row.period).format('YYYY-MM-DD') }}</template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="contactInfo" label="联系方式" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="amount" label="金额" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">￥{{ row.amount}}</template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageModel.page" :page-size="Number(listQuery.pageModel.rows)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="导入历史发薪" :visible.sync="showImport" width="500px">
      <el-form label-width="100px">
        <el-form-item label="导入模板:">
          <el-button type="text" class="blueName cp" @click="downImportTemp">下载模板</el-button>
        </el-form-item>
        <el-form-item label="上传文件" prop="fileUrl">
          <el-upload class="upload-demo" action="" :on-remove="handleRemove" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed" :on-change="handleUpload" accept=".xlsx,.xls" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImport()" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import moment from "moment";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    file
  } from "jszip";
  export default {
    data() {
      return {
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [],
          },
          branchCompany: '',
          projectName: '',
          name: '',
          idCardNumber: '',
          contactInfo: '',
          period: '',
          amount: null,
          taxDeclarationType: '',
          legalEntity: ''
        },
        showDropScreen: -1,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        legList: [],
        id: '',
        showImport: false,
        fileUrl: '',
        fileList: [],
        isBtnLoading: false,
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      this.getProList();
      this.getList();
      this.getlegalsubjectlist();
    },
    methods: {
      checkPermission,
      //获取法务主体列表
      getlegalsubjectlist() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
           this.legList = [];
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      getList() {
        xz.ArdCurStat(this.listQuery, 'GetHistoricalPayrollList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      del(row) {
        xz.CancellApplication(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.$message.success('作废成功！')
          } else {
            this.getList();
            this.$message.error(res.msg);
          }
        })
      },
      expHandle() {
        this.isBtnLoading = false;
        this.fileUrl = '';
        this.fileList = [];
        this.showImport = true;
      },
      downImportTemp() {
        var path = this.$store.state.EMP.tablePath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20250928154208016.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.setAttribute('download', '导入历史发薪模板.xlsx');
        aTag.click();
      },
      handleUpload(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.fileUrl = res;
          } else {
            this.fileUrl = ''
          }
        });
      },
      handleRemove() {
        this.fileUrl = '';
        this.fileList = [];
      },
      handleExceed() {
        this.$message.warning(`最多上传 1 个文件，请先删除再上传`);
      },
      confirmImport() {
        if (this.fileUrl) {
          let d = {
            fileUrl: this.fileUrl
          }
          xz.ArdCurStat(d, 'ImportHistoricalPayroll').then(res => {
            if (res.status == 'ok') {
              this.$message.success('导入成功！');
              this.isBtnLoading = false;
              this.showImport = false;
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }
</style>
<style>
  .page_zeroRepairList .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_zeroRepairList .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_zeroRepairList .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_zeroRepairList .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_zeroRepairList .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_zeroRepairList .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>